export enum StandingAccessKeys {
  listReports = 'standingAccess/listReports',
  getReport = 'standingAccess/getReport',
  countResources = 'standingAccess/countResources',
  getReportEntitlements = 'standingAccess/getReportEntitlements',
  getReportUsages = 'standingAccess/getReportUsages',
  getReportResourcesFilterOptions = 'standingAccess/getReportResourcesFilterOptions',
  getReportPermissionsFilterOptions = 'standingAccess/getReportPermissionsFilterOptions',
  getReportRiskScoresFilterOptions = 'standingAccess/getReportRiskScoresFilterOptions',
  getReportTierCounts = 'standingAccess/getReportTierCounts',
  getAccessFlowRemediation = 'standingAccess/getAccessFlowRemediation',
  getRemediatedAccessFlows = 'standingAccess/getRemediatedAccessFlows',
  getReportEntitlementLinks = 'standingAccess/getReportEntitlementLinks',
  getReportLinkedElementsFilterOptions = 'standingAccess/getReportLinkedElementsFilterOptions',
}
